import { D3Selection } from "svg/draw/draw-calendar";
import {
    CustomImage,
    ImageDetails,
    PrintPdfFontResponse,
    TextInformation,
} from "burde";
import { BleedSize, CalendarSizeDimensions } from "svg/constants";
import { drawCoverText } from "svg/draw/draw-cover-text";
import { getImageUrlByCalendarSize } from "svg/helpers";

const drawCoverPage = (
    svg: D3Selection,
    calendarSize: string,
    calendarDimensions: CalendarSizeDimensions,
    coverImage: ImageDetails | null,
    coverColor: string | null,
    customCoverImage: CustomImage | null,
    coverTexts: Array<TextInformation>,
    fontOptions: PrintPdfFontResponse | null,
) => {
    var background = svg.append("g").classed("background-content", true);

    if (customCoverImage) {
        background
            .append("svg:image")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr("xlink:href", `${customCoverImage.url}`)
            .attr("preserveAspectRatio", "xMidYMid slice");
    } else if (coverImage && coverImage.id !== null) {
        background
            .append("svg:image")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr(
                "xlink:href",
                coverImage.endpoints &&
                    getImageUrlByCalendarSize(
                        coverImage.endpoints,
                        calendarSize,
                    ),
            )
            .attr("preserveAspectRatio", "xMidYMid slice");
    } else if (coverColor) {
        background
            .append("rect")
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr("fill", coverColor);
    }

    // Content coordinate system will start at 0 0 for upper left and will not take bleeds in to account
    let content = svg
        .append("g")
        .attr("transform", `translate(${BleedSize}, ${BleedSize})`)
        .classed("main-content", true);

    if (coverTexts && coverTexts.length > 0) {
        for (let i = 0; i < coverTexts.length; i++) {
            drawCoverText(content, coverTexts[i], i, fontOptions);
        }
    }
};

export { drawCoverPage };
